// Login.js
// Form Input refs: https://stackoverflow.com/a/65885351

import React, { useEffect, useRef, useState } from "react";
import { Image, StyleSheet, Text, TouchableOpacity, View, Platform } from "react-native";
//import AsyncStorage from "@react-native-async-storage/async-storage";
import Button from "../../Partials/Buttons";
import TextInputRef from "../../Partials/TextInputRef";
import formRefs from "../../helpers/formrefs";
import logo from "../../assets/logo.png";
import { ScreenLoading } from "../../Partials/Status";
import { triggerAlert } from "../../Partials/AlertModal";

const Login = () => {
  const _theme = window.main.theme;
  const [isScreenLoading, setIsScreenLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const loginFormRefs = useRef(new formRefs());

  const onSubmit = async () => {
    const formData = loginFormRefs.current.getAll();
    formData.remember_me = rememberMe ? 1 : 0;
    if (!("username" in formData) || !formData.username.trim()) {
      triggerAlert({
        show: true,
        title: "Login Email is required",
        message: "Please enter your user email to login.",
        onConfirmPressed: async () => {
          // Close this modal
          triggerAlert();
          // Re-focus the input
          // loginFormRefs.current.getRef("username").current.focus();
        },
      });
      return false;
    }
    if (!("password" in formData) || !formData.password || formData.password.trim().length < 8) {
      triggerAlert({
        show: true,
        title: "Password is required",
        message: "Please enter your password to login.",
        onConfirmPressed: async () => {
          // Close this modal
          triggerAlert();
          // Re-focus the input
          // loginFormRefs.current.getRef("password").current.focus();
        },
      });
      return false;
    }
    // Submit
    try {
      setIsScreenLoading(true);
      const postData = {};
      for (const field in formData) {
        postData[field] = formData[field];
      }
      const login_resp = await window.main.axios.post(window.main.api.login, postData);
      if (!!login_resp.data?.loggedin) {
        const profile_resp = await window.main.axios.get(window.main.api.session);
        window.main.lib.setUserProfile(profile_resp?.data || {});
        window.main.lib.setTempIsLoggedin(true);
        window.main.lib.setTempIsSessionChecked(true);
        window.main.lib.triggerMainState();
        window.main.lib.setCurrentView("home");
        window.main.lib.setLoadingState(false);
        return;
      } else {
        return window.setTimeout(() => {
          triggerAlert({
            show: true,
            title: "Oops!",
            message: (login_resp.data?.error || "Invalid login.\nPlease try again."),
            showConfirmButton: true,
            confirmText: "Ok",
            onConfirmPressed: () => {
              triggerAlert();
            },
          });
        },1);
      }
    } catch (err) {
      // Non-200 response...
      console.log("API response error:", err);
      // Non-200 response...
      setIsScreenLoading(false);
      let errMsg = window.main.lib.parseErrorMessage(err);
      if (!errMsg || typeof(errMsg)!=="string") {
        errMsg = "An error occurred.\nPlease try again."
      }
      triggerAlert({
        show: true,
        title: "Oops!",
        message: errMsg,
        showConfirmButton: true,
        confirmText: "Ok",
        onConfirmPressed: () => {
          triggerAlert();
        },
      });
    }
  };

  const onRegister = async () => {
    window.main.lib.setCurrentView("register");
  };

  const onForgotPassword = async () => {
    window.main.lib.setCurrentView("passwordreset");
  };

  const onKeyPressEnterSubmit = (e)=>{
    if(e.key==="Enter") {
      onSubmit();
    }
  };

  const styles = StyleSheet.create(window.main.theme.externalUserPagesStyles);
  const _username_ref = useRef();
  const _password_ref = useRef();
  // LoginForm
  return (
    <View style={{...styles.container,position:"static"}}>
      <View style={{...styles.wrapper,flexDirection:"column",alignItems:"center",position:"static"}}>
        <View style={styles.headerRow}>
          <Image nativeID={"brand_logo"} style={styles.headerLogo} source={logo} resizeMode={"cover"} accessibilityLabel={"VetManaged Logo"} />
          <Text nativeID={"app_title"} style={ styles.headerTitle }> VetManaged</Text>
        </View>
        <View style={styles.headerRow}>
          <Text style={ styles.headerTitle }>Pet Parent Login</Text>
        </View>
        <View style={{width:250,alignSelf:"center"}}>
          <TextInputRef key="login_un" ref={_username_ref} nativeID="input_username" textContentType="username" autoComplete="username" formrefs={loginFormRefs.current} datakey={"username"} placeholder="Username..." style={{...window.main.theme.textInputLarge,width:300}} clearButtonMode="always" onKeyPress={onKeyPressEnterSubmit} autoFocus={true} />
          <TextInputRef key="login_pw" ref={_password_ref} nativeID="input_password" textContentType="password" autoComplete="password" formrefs={loginFormRefs.current} datakey={"password"}placeholder="Password..." style={{...window.main.theme.textInputLarge,width:300,marginBottom:12}} clearButtonMode="always" secureTextEntry={true} onKeyPress={onKeyPressEnterSubmit} />
          <TouchableOpacity onPress={() => setRememberMe((prev) => !prev)} accessibilityRole="switch" accessibilityState={{ checked: rememberMe }} style={{alignItems:"center",alignSelf:"center",flexDirection:"row",marginBottom:20,marginTop:0,paddingLeft:0,width:250}}>
            <View style={{backgroundColor:(rememberMe?"#1b8f2e":"#d9d9d9"),borderRadius:_theme.borderRadius,height:22,justifyContent:"center",padding:3,width:38}}>
              <View style={{alignSelf:(rememberMe?"flex-end":"flex-start"),backgroundColor:"#fff",borderRadius:8,height:16,width:16}} />
            </View>
            <Text style={{color:"#707070",fontSize:16,marginLeft:10}}>
              Remember Me
            </Text>
          </TouchableOpacity>
        </View>
        <Button nativeID="button_login" type="primary" ficon="log-in" text=" Login" onpress={onSubmit} style={{width:250}} />
        <Button nativeID="button_register" type="link" text="Sign Up!" onpress={onRegister} style={{width:260,marginTop:20}} />
        <Button nativeID="button_register" type="link" text="Forgot Password" onpress={onForgotPassword} style={{width:260,marginTop:10}} />
        <ScreenLoading loadingState={isScreenLoading} style={{paddingTop:100,opacity:0.7}} />
      </View>
    </View>
  );
};

export default Login;
